(function () {
  'use strict';

  angular.module('ringbaPortal').controller('DashboardTopStatsController', DashboardTopStatsController);

  function DashboardTopStatsController(
    _,
    $interval,
    $scope,
    accountsService,
    statsService,
    userSettingsService,
    dashboardTopStatsService,
    columnsFetchService,
    utils
  ) {

    const vm = this;
    const numberOfTops = 30;
    const hours = 24;

    vm.currentStatsTab = 'publishers';
    vm.loading = true;

    vm.affiliateColumnSettings = _.cloneDeep(dashboardTopStatsService.topColumnSettings);
    vm.targetColumnSettings = _.cloneDeep(dashboardTopStatsService.targetColumnSettings);
    vm.campaignColumnSettings = _.cloneDeep(dashboardTopStatsService.topColumnSettings);

    userSettingsService.getUserSettings()
      .then(function (userSettings) {
        vm.userSettings = userSettings;
        vm.affiliateTopColumns = columnsFetchService.getColumnList(userSettings, dashboardTopStatsService.affiliateDefaultColumns, 'affiliateTop');
        vm.targetTopColumns = columnsFetchService.getColumnList(userSettings, dashboardTopStatsService.targetDefaultColumns, 'targetTop');
        vm.campaignTopColumns = columnsFetchService.getColumnList(userSettings, dashboardTopStatsService.campaignDefaultColumns, 'campaignTop');
        return _loadTopStats();
      })
      .catch(utils.errorHandler);

    const timer = $interval(function () {
      _loadTopStats();
    }, 15000);

    function _loadTopStats() {
      statsService.getTopStatsByHour(accountsService.currentAccountId, hours)
        .then(function (response) {
          vm.loading = false;
          vm.topPublishers = _.sortBy(response.data.top.affiliate, function (el) { return el.values.inboundcall; }).reverse().slice(0, numberOfTops);
          vm.topTargets = _.sortBy(response.data.top.target, function (el) { return el.values.connectedcall; }).reverse().slice(0, numberOfTops);
          vm.topCampaigns = _.sortBy(response.data.top.campaign, function (el) { return el.values.inboundcall; }).reverse().slice(0, numberOfTops);

          vm.topTargets = vm.topTargets.map(function (value) {
            if (value.id.substring(0, 2) === 'PI') {
              value.stateName = 'dashboard.ringtreetarget.edit';
              value.stateParams = {
                name: value.name,
                pingTreeTargetId: value.id
              };
              value.targetEdit = value.stateName+'('+ JSON.stringify(value.stateParams)+')';
            } else {
              value.stateName = 'dashboard.target.edit';
              value.stateParams = {
                name: value.name,
                targetId: value.id
              };
              value.targetEdit = value.stateName+'('+ JSON.stringify(value.stateParams)+')';
            }
            return value;
          });
        });
    }

    $scope.$on('$destroy', function () {
      $interval.cancel(timer);
    });
  }
})();
